import React, { ChangeEvent } from 'react';

import { Tumbler } from '@yandex-360/orb-components/dist/components/Tumbler';
import cn from 'classnames';

import css from './index.css';

type OrbTumblerProps = React.ComponentPropsWithoutRef<typeof Tumbler>;
export type Props = Omit<OrbTumblerProps, 'onChange'> & {
    onChange: (event?: ChangeEvent<HTMLInputElement>) => void;
    stretch?: boolean;
    shrink?: boolean;
};

export const Switch = ({ className, stretch, ...props }: Props) => {
    return (
        <Tumbler
            className={cn(className, {
                [css.TumblerStretch]: stretch,
            })}
            {...props}
        />
    );
};
